import CreditSVG from "@/../../hypetrain/static/img/credit.svg";
import LockSVG from "@/../../hypetrain/static/img/lock.svg";
import { EmbedSvg } from "@/components/helpers/ui/EmbedSvg";
import { Box, Flex } from "@/components/layout/flexbox";
import { BRAND_PURPLE, INNER_BORDER_COLOR } from "@/css/constants";
import { formatCredits } from "@/utils/string";

const borderStyles = (isSelected: boolean) => ({
  borderRadius: 8,
  borderWidth: 3,
  borderStyle: "solid",
  borderColor: isSelected ? BRAND_PURPLE : INNER_BORDER_COLOR,
});

interface CreditPriceOptionProps {
  price: string;
  isSelected?: boolean;
  isLocked?: boolean;
  noBorder?: boolean;
  css?: object;
  onClick?: () => void;
}

export function CreditPriceOption({
  price,
  isLocked = false,
  isSelected = false,
  noBorder = false,
  css = {},
  onClick,
}: CreditPriceOptionProps) {
  const containerStyle = {
    ...(noBorder ? {} : borderStyles(isSelected)),
    opacity: isLocked ? 0.5 : 1,
    height: 60,
    padding: 20,
    cursor: isLocked ? "not-allowed" : "pointer",
    ...(css as object),
  };

  return (
    <Flex alignItems={"center"} css={containerStyle} onClick={onClick}>
      <EmbedSvg src={CreditSVG} height={16} width={16} />
      <Box flexGrow={1} ml={10} fontWeight={600}>
        {formatCredits(price)}
      </Box>
      {isLocked && <EmbedSvg src={LockSVG} height={16} width={16} />}
    </Flex>
  );
}
